<template>
  <div class="layout-footer">
    <!-- Copyright 2020 版权信息 -->
    <!-- 备案号：苏ICP备20042564号-1 -->
    <!-- &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;版权所有：小犀新能源科技（南京）有限公司 -->
  </div>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {};
  }
};
</script>

<style scoped lang="less">
@import "./Footer.less";
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue